import {Injectable} from '@angular/core';
import {SaleProductDataService} from './SaleProductData.service';
import {SaleProductSummaryModel} from '../../../api/entity/saleProductSummary.model';
import {SaleProductModel} from '../../../api/entity/saleProduct.model';
import {SaleProductSummaryConverter} from '../../../api/converter/saleProductSummary.converter';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';

@Injectable({providedIn: 'root'})
export class SaleProductSummaryDataServiceAdapter
    extends AbstractDataServiceDtoSummaryAdapter<SaleProductSummaryModel,
        SaleProductSummaryConverter, SaleProductModel> {
    constructor(dataService: SaleProductDataService, converter: SaleProductSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): SaleProductModel {
        return new SaleProductModel();
    }
}
